export enum UserProfileRole {
  MANAGER = 'MANAGER',
  NONMANAGER = 'NONMANAGER',
}

export interface ILocation {
  country: string;
  state?: string;
}

export interface IFullUser {
  // users
  id: number;
  isEmailVerified: boolean;
  name: string;
  primaryEmail: string;
  // user_profiles minus id
  companyId: number;
  country: string;
  customCategory?: string;
  department?: string;
  isManager: boolean;
  language: string;
  managedByService?: string;
  managerUserId?: number;
  nudgePersona?: string;
  state?: string;
  status: string;
  timezone: string;
  userId: number;
}

export interface IUserPopulationAttributes {
  customCategoryValues?: string[];
  departments?: string[];
  employeeTypes?: string[];
  locations?: ILocation[];
  roles?: UserProfileRole[];
}
